import React from "react";
import Tweets from "../Tweets";


const TweetList = () => {
  return(
      <div>
        <Tweets/>
      </div>
  );
};
export default TweetList;
